// 主題頁籤的定義與可用性判斷。
//
// 這份對照表原本同時存在於 ThemeNavigator.vue 與 Content.vue，兩邊各一份，
// 新增卡片時要記得同時改。現在集中在這裡，需要判斷頁籤數量的地方也不必再抄第三份。

import { StationList, resolveExcludedThemes } from './constants'

// 頁籤顯示的名稱在語系檔的 theme-name.<id>，這裡不放，
// 否則切成英文時整排頁籤還是中文。
export const THEMES = [
    { id: 'all', status: 'online' },
    { id: 'environment', status: 'online' },
    { id: 'disaster', status: 'online' },
    { id: 'energy', status: 'online' },
    { id: 'microgrid', status: 'online' },
    { id: 'meteor', status: 'online' },
]

// 每個主題包含哪些卡片
export const THEME_MAP = {
    environment: ['air_gas', 'air_particle', 'water'],
    disaster: ['tilt', 'gps', 'rain'],
    energy: ['solar', 'pressure', 'wind', 'rain', 'humid', 'temp'],
    // 微電網：能流圖鋪滿上方一列，下方小卡。
    // solar 與 temp 是現成卡片，日照與溫度用來解釋發電量高低。
    // 中大白色能源屋沒有自己的氣象感測器，只留下日照，temp 已在 excludedData 排除。
    microgrid: ['energy_flow', 'today_energy', 'battery', 'carbon', 'solar', 'temp'],
    meteor: ['meteor'],
}

// 主題的關鍵卡片：有指定者改判關鍵卡是否被排除，而非「至少一張卡沒被排除」。
// 微電網含 solar 與 temp，而羅浮並未排除這兩張，若用通則判斷，即使微電網卡
// 全被排除，羅浮仍會出現一個只剩日照與溫度的「微電網」頁籤。
export const THEME_KEY_CARD = {
    microgrid: 'energy_flow',
}

/**
 * 算出某個站點看得到哪些主題頁籤。
 *
 * @param {string} stationId 站點代碼
 * @returns {Array} THEMES 的子集合
 */
export function getAvailableThemes(stationId) {
    const station = StationList.find((s) => s.id === stationId)
    const excludedData = station ? station.excludedData : []
    // 只剩單一主題的站點不需要總覽，總覽與該主題內容完全重複（中大白色能源屋、
    // 羅浮高中、巴陵行政中心），由站點自己在 excludedThemes 指定
    const excludedThemes = resolveExcludedThemes(stationId)

    return THEMES.filter((theme) => {
        if (excludedThemes.includes(theme.id)) return false
        if (theme.id === 'all') return true // 「全部」預設永遠顯示

        // 有關鍵卡的主題，關鍵卡被排除就整個頁籤不顯示
        const keyCard = THEME_KEY_CARD[theme.id]
        if (keyCard) return !excludedData.includes(keyCard)

        // 只要這個主題內「至少有一張」卡片不在排除名單內，就顯示該頁籤
        return (THEME_MAP[theme.id] || []).some((cardId) => !excludedData.includes(cardId))
    })
}
